import { Form } from "antd";
import SearchSubmit from "../SearchSubmit/SearchSubmit";

export default function SubmitComponent() {
  return (
    <Form.Item className="m-0! w-full items-center justify-center md:flex md:w-min">
      <SearchSubmit className="w-full! p-3! md:w-min!" />
    </Form.Item>
  );
}
